import { TestimonialCarousselAuto } from '../../layouts/TestimonialCarousselAuto';
import { classNames } from '../../utils/style';
import React from 'react';

import './TestimonialCarousselAutoSection.scss';
import {
  fontBodyMiniMedium,
  fontHeading2,
} from '../../styles/typographyNew';

export const TestimonialCarousselAutoSection = ({
  logo,
  tag,
  title,
  cardsFirstLine,
  cardsSecondLine,
}: any) => {
  return (
    <div className="TestimonialCarousselAutoSection">
      {logo && <div className="max-w-[135px] w-full mx-auto">{logo}</div>}
      {tag && (
        <div
          className={classNames(
            fontBodyMiniMedium,
            'rounded-[70px] mx-auto text-center',
            logo && 'mt-24',
            'shadow-tagTestimonial',
            'py-[6px] px-12 w-fit',
            'text-[#042040]',
          )}
        >
          {tag}
        </div>
      )}
      {title && (
        <h2
          className={classNames(
            fontHeading2,
            'max-w-[890px] text-center',
            'mt-32 mx-16',
            'md:mx-auto max-w-[889px]',
            'text-[#042040]',
            'whitespace-pre-line',
          )}
        >
          {title}
        </h2>
      )}

      {cardsFirstLine?.length > 0 && (
        <div className="mt-[60px]">
          <TestimonialCarousselAuto cards={cardsFirstLine} />
        </div>
      )}
      {cardsSecondLine?.length > 0 && (
        <div
          className={classNames(
            cardsFirstLine?.length > 0 ? '' : 'mt-[60px]',
            'hidden md:block',
          )}
        >
          <TestimonialCarousselAuto inverse={false} cards={cardsSecondLine} />
        </div>
      )}
    </div>
  );
};
